const productsShopping = [
  {
    id: 55,
    pinPos: [844.5093503040201, 573.3813956810592, -2007.9400238053738],
    scale: 2.8,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 1083.0908349910997,
        y: 413.279147597914,
        z: -1134.4825671176968,
      },
      target: {
        x: 1082.6942884515245,
        y: 413.38604441631685,
        z: -1135.3943367772963,
      },
      posMobile: {
        x: 1083.0908349910997,
        y: 413.279147597914,
        z: -1134.4825671176968,
      },
      targetMobile: {
        x: 1082.6942884515245,
        y: 413.38604441631685,
        z: -1135.3943367772963,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24965863311374,
        y: 230.6792307404816,
        z: 174.96833346295142,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 56,
    pinPos: [-1878.9830702160607, 278.5317179526975, -1033.9259277324522],
    scale: 2.6,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -909.2769597318803,
        y: 234.18652813015484,
        z: -113.51236297663411,
      },
      target: {
        x: -910.1206118525585,
        y: 234.2045596068755,
        z: -114.04895030887597,
      },
      posMobile: {
        x: -909.2769597318803,
        y: 234.18652813015484,
        z: -113.51236297663411,
      },
      targetMobile: {
        x: -910.1206118525585,
        y: 234.2045596068755,
        z: -114.04895030887597,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24965863311374,
        y: 230.6792307404816,
        z: 174.96833346295142,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 57,
    pinPos: [1324.3970090135433, 624.4749426393465, -2175.819019819683],
    scale: 2.8,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 934.855180029913,
        y: 354.5216759612831,
        z: -1188.220834829934,
      },
      target: {
        x: 935.061532014868,
        y: 354.8027589970831,
        z: -1189.158070758231,
      },
      posMobile: {
        x: 934.855180029913,
        y: 354.5216759612831,
        z: -1188.220834829934,
      },
      targetMobile: {
        x: 935.061532014868,
        y: 354.8027589970831,
        z: -1189.158070758231,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24965863311374,
        y: 230.6792307404816,
        z: 174.96833346295142,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 58,
    pinPos: [161.53374985695828, 37.54469553939873, -248.45929940860543],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 168.08206284807974,
        y: 197.5610022614495,
        z: -27.744993394028757,
      },
      target: {
        x: 167.89201090985668,
        y: 196.97130059900363,
        z: -28.52993428994783,
      },
      posMobile: {
        x: 168.08206284807974,
        y: 197.5610022614495,
        z: -27.744993394028757,
      },
      targetMobile: {
        x: 167.89201090985668,
        y: 196.97130059900363,
        z: -28.52993428994783,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24965863311374,
        y: 230.6792307404816,
        z: 174.96833346295142,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 59,
    pinPos: [-871.0340466982396, 624.719705627283, -667.3536663082659],
    scale: 2,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -989.7533541841683,
        y: 313.5848167474328,
        z: -41.5432202396007,
      },
      target: {
        x: -989.7521398537128,
        y: 314.0325986080664,
        z: -42.437362247723044,
      },
      posMobile: {
        x: -989.7533541841683,
        y: 313.5848167474328,
        z: -41.5432202396007,
      },
      targetMobile: {
        x: -989.7521398537128,
        y: 314.0325986080664,
        z: -42.437362247723044,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24965863311374,
        y: 230.6792307404816,
        z: 174.96833346295142,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
];

export default productsShopping;
